import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getAgreementRequirementSettings } from '@user/store/closingRequirements/api'
import { ClosingAgreementRequirementsModel } from '@user/store/closingRequirements/typings'
import { unwrapResult } from '@reduxjs/toolkit'

export const useGetAgreementRequirementsOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  const [agreementRequirements, setAgreementRequirements] = useState<
    ClosingAgreementRequirementsModel[]
  >([])

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')

        const result = await dispatch(getAgreementRequirementSettings())

        if (mounted) {
          if (getAgreementRequirementSettings.fulfilled.match(result)) {
            setAgreementRequirements(unwrapResult(result))
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return { agreementRequirementsStatus: status, agreementRequirements }
}
